import React from 'react'
import Reflux from 'reflux'
import _ from 'lodash'

import RecipesStore from '~/stores/recipes.js'

import SimpleSelect from '~/modules/_core/simpleSelect.jsx'


export default class ShoppingListSelectRecipe extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = RecipesStore
	}

	render() {
		const recipeNotSelected = _.filter(this.state.list, rec => this.props.existingRecipes.indexOf(rec.recipeID) === -1)
		const recipeList = (this.props.categoryID > 0)
			? _.filter(recipeNotSelected, rec => rec.categoryID === this.props.categoryID)
			: recipeNotSelected

		const passOptions = _.sortBy(recipeList, 'recipe')

		return (
			<SimpleSelect
				onChange={this.props.onChange}
				name="recipeID"
				value={this.props.value}
				options={passOptions}
				itemKeyValue="recipeID"
				itemKeyLabel="recipe"
				labelForBlank="Select recipe"
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/shoppingList/selectRecipe.jsx